import { Grid } from "@mui/material";
import React from "react";
import "./creator.css";
function PopularC() {
  const popData = [
    {
      popSrc: "./Assets/p_c_1.png",
      popId: "@hamza_pitts...",
      popPrice: "19.4 ETH",
    },
    {
      popSrc: "./Assets/p_c_2.png",
      popId: "@nathan_walls...",
      popPrice: "24.13 ETH",
    },
    {
      popSrc: "./Assets/p_c_3.png",
      popId: "@kelton_collier...",
      popPrice: "62.68 ETH",
    },
    {
      popSrc: "./Assets/p_c_4.png",
      popId: "@cade_glover...",
      popPrice: "32.48 ETH",
    },
    {
      popSrc: "./Assets/p_c_5.png",
      popId: "@teagan_poole...",
      popPrice: "50.02 ETH",
    },
    {
      popSrc: "./Assets/p_c_6.png",
      popId: "@austin_rivera...",
      popPrice: "9.99 ETH",
    },
    {
      popSrc: "./Assets/p_c_7.png",
      popId: "@leonel_carey...",
      popPrice: "4.58 ETH",
    },
    {
      popSrc: "./Assets/p_c_8.png",
      popId: "@kolten_hart...",
      popPrice: "3.58 ETH",
    },
  ];
  return (
    <div className="pop_main">
      <h1 className="pop_creator">Popular Creators</h1>
      <div className="seprator"></div>
      <Grid
        container
        sx={{
          justifyContent: {
            xs: "center",
            sm: "center",
            md: "space-between",
            lg: "space-between",
          },
        }}
      >
        {popData.map((e) => {
          return (
            <Grid item xs={12} sm={10} md={2.9} lg={2.9}>
              <div className="pop_card">
                <img src={e.popSrc} alt="" className="pop_img" />
                <h2 className="pop_id">{e.popId}</h2>
                <p className="pop_price">{e.popPrice}</p>
              </div>
            </Grid>
          );
        })}
      </Grid>

      <div className="pop_btn">
        <button className="common_btn">View More</button>
      </div>
    </div>
  );
}

export default PopularC;
